import { Injectable } from '@angular/core';
import { DataService  } from "../../shared/services/data.service";
import { Observable, tap } from 'rxjs';
import {ResponseModel} from "../../shared/model/response.model"

@Injectable({
  providedIn: 'root'
})
export class SalonListsService {

  constructor(private service: DataService) {}
  getAllUserList(data: any): Observable<ResponseModel> {
    let url = 'api/admin/getallsalaonlist';    
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getAllDashbordList(): Observable<ResponseModel> {
    let url = 'api/admin/getalldashboardlist';    
    return this.service.get(url, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  updateUserStatus(data: any): Observable<ResponseModel> {
    let url = 'api/admin/updateuserstatusbyadmin';    
    return this.service.put(url,data).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getAllFreeSalonList(data: any): Observable<ResponseModel> {
    let url = 'api/admin/getallfreesalonlist';    
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getAllPremiumSalonList(data: any): Observable<ResponseModel> {
    let url = 'api/admin/getallpremiumsalonlist';    
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getRegisteredStaffList(data: any): Observable<ResponseModel> {
    let url = 'api/admin/getstaffregisterlist';    
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }

  getUserTransactionDetails(id:any): Observable<ResponseModel> {
    const url = `api/admin/getusertransactiondetails?Id=${id}`; 
    return this.service.get(url, true).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getAllExpiredSalonList(data: any): Observable<ResponseModel> {
    let url = 'api/admin/getallexpiredsalonlist';    
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getRegisteredStaffSalonList(data: any): Observable<ResponseModel> {
    let url = 'api/admin/getRegisteredStaffSalonList';
    return this.service.post(url, data).pipe<ResponseModel>(
      tap((response: any) => {
        return response;
      })
    );
  }
  getSortableDate(dateStr: string): string {
    let date: Date;
 
    if (dateStr === 'Today') {
      date = new Date();
    } else if (dateStr === 'Yesterday') {
      date = new Date();
      date.setDate(date.getDate() - 1);
    } else {
      return dateStr;
    }
 
    const d = String(date.getDate()).padStart(2, '0');
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const y = String(date.getFullYear()).slice(-2);
 
    return `${d}/${m}/${y}`;
  }
  
}
